import styled from 'styled-components';

import {
  xdlColorBackgroundTertiary,
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  scale070,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const OuterWrapper = styled.div`
  padding: ${spaceS} 0;

  @media (min-width: 1113px) {
    border-bottom: 1px solid ${xdlColorBackgroundTertiary};
  }
`;

export const ListWrapper = styled.ul`
  list-style: none;
  padding-left: ${spaceL};
  padding-right: ${spaceL};

  @media (min-width: 1113px) {
    display: flex;
    justify-content: space-between;
    padding: 0 ${spaceXL};
  }
`;

export const ListItem = styled.li`
  display: flex;
  align-items: flex-start;

  & :first-child {
    padding-left: 0;
  }

  @media (min-width: 1113px) {
    padding-left: ${spaceXXL};
  }
`;

export const Icon = styled.span`
  margin-right: ${spaceL};
`;

export const ListText = styled(BodyCopy)`
  font-size: 12px;
`;

export const ListDesktop = styled.span`
  display: none;

  @media (min-width: 1113px) {
    display: block;
  }
`;

export const DropdownWrapper = styled.div`
  & > div {
    border-top: none;
  }

  & .listItem {
    margin-bottom: ${spaceL};
  }

  & .dropdown {
    display: flex;
    align-items: center;
    min-height: 40px;
    padding-top: ${spaceM};
    padding-bottom: ${spaceM};
  }

  @media (min-width: 1113px) {
    display: none;
  }
`;

export const DropdownText = styled(BodyCopy)`
  font-weight: 700;
  font-size: ${scale070};
  margin-bottom: 0;
`;
